module.exports = __webpack_public_path__ + "static/step.19717d76.png";